const Foundation = {
  borderRadius: '11px',
  height: '38px',
  buttonWidth: '143px',
  borderWidth: '2px',
}

module.exports = { Foundation }
